module.exports = "<svg id=\"b0df5c60-519f-4204-a346-8c1e6d266729\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow-down</title><path d=\"M45.23,13.86,28,27.69v-.1L25,30l-2.94-2.38v.07L4.78,13.86a3.12,3.12,0,0,0-4.13.46,2.94,2.94,0,0,0,.46,4.13L23.17,36.1a2.67,2.67,0,0,0,1.84.64h0a4.18,4.18,0,0,0,1.83-.64L48.9,18.45a2.94,2.94,0,0,0,.46-4.13A3,3,0,0,0,45.23,13.86Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = 548
// module chunks = 1